export default __webpack_public_path__ + "static/newspaper-6df7dfc33bab239d15d170a49e70c294.png";